import React, { useState, useRef } from "react";
import { Button } from "../components/Button";
import { styled } from "../stitches.config";
import Popover from "../components/Popover";
import { Input } from "../components/Form";
import { useSendAnalyticsEvent } from "../analytics/events";

export default function Share() {
  const [copied, setCopied] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const sendAnalyticsEvent = useSendAnalyticsEvent();

  return (
    <Popover
      label={<em>Share</em>}
      title="Share URL"
      onOpenChange={(open) => {
        if (!open) setCopied(false);
        if (open) sendAnalyticsEvent({ name: "shareButtonClicked" });
      }}
    >
      <Input
        value={window.location.href}
        readOnly
        size="small"
        onClick={() => inputRef.current!.select()}
        ref={inputRef}
        aria-label="Link to space"
      />
      <Button
        size="large"
        color="primary"
        onClick={() => {
          navigator.clipboard
            .writeText(window.location.href)
            .then(() => setCopied(true));
        }}
      >
        {copied ? "Link copied!" : "Copy link"}
      </Button>
      <InfoText>
        Share this link with your friends and invite them to the space. <br />
        No signup needed!
      </InfoText>
    </Popover>
  );
}

const InfoText = styled("p", {
  lineHeight: "$4",
  fontSize: "$3",
});
